import { editUser } from '../../_services/user.service';
import { getCompany } from '../../_utils/storage_handler';
import { 
    buildCreateUserBody,
    validateEditUserBody
} from './create_user.input';

export const editProfileEvent = async (id) => {
    let body = buildCreateUserBody(getCompany());
    validateEditUserBody(body);
    let res = await editUser(body, id);
    if(! res.ok){
        throw new Error(res.error);
    }
    
    return res;
}